export const FundingSearchStatus = Object.freeze({
  submitted: 0,
  inProgress: 1,
  reviewing: 2,
  approved: 3,
  withBroker: 4,
  declined: 5,
  canceled: 6,
  incomplete: 7,
  atOffer: 8,
  withCreditCommittee: 9,
  paidOut: 10,
  awaitingDocuments: 11,
  capitaliseReview: 12,
  onHold: 13,
  awaitingClient: 14,
  awaitingClientContact: 15,
});

export const FundingSearchStatusLabel = Object.freeze({
  [FundingSearchStatus.submitted]: 'Submitted',
  [FundingSearchStatus.inProgress]: 'In Progress',
  [FundingSearchStatus.reviewing]: 'Reviewing',
  [FundingSearchStatus.approved]: 'Approved',
  [FundingSearchStatus.withBroker]: 'With Broker',
  [FundingSearchStatus.declined]: 'Declined',
  [FundingSearchStatus.canceled]: 'Canceled',
  [FundingSearchStatus.incomplete]: 'Incomplete',
  [FundingSearchStatus.atOffer]: 'At Offer',
  [FundingSearchStatus.withCreditCommittee]: 'With Credit Committee',
  [FundingSearchStatus.paidOut]: 'Paid out',
  [FundingSearchStatus.awaitingDocuments]: 'Awaiting Documents',
  [FundingSearchStatus.capitaliseReview]: 'Capitalise Review',
  [FundingSearchStatus.onHold]: 'On Hold',
  [FundingSearchStatus.awaitingClient]: 'Awaiting Client',
  [FundingSearchStatus.awaitingClientContact]: 'Awaiting Client Contact',
});

export function isValid(type) {
  return Object.values(FundingSearchStatus).find((elem) => elem === type);
}

export function toLabel(type) {
  return FundingSearchStatusLabel[type];
}

export function isColorGreen(type) {
  switch (type) {
    case FundingSearchStatus.reviewing:
    case FundingSearchStatus.approved:
    case FundingSearchStatus.atOffer:
    case FundingSearchStatus.paidOut:
    case FundingSearchStatus.capitaliseReview:
      return true;

    default:
      return false;
  }
}

export function isColorYellow(type) {
  switch (type) {
    case FundingSearchStatus.awaitingDocuments:
    case FundingSearchStatus.onHold:
    case FundingSearchStatus.awaitingClient:
      return true;

    default:
      return false;
  }
}

export function isColorRed(type) {
  switch (type) {
    case FundingSearchStatus.declined:
    case FundingSearchStatus.canceled:
      return true;

    default:
      return false;
  }
}

export const FundingSearchStatusChipColor = Object.freeze({
  [FundingSearchStatus.submitted]: 'grey',
  [FundingSearchStatus.inProgress]: 'grey',
  [FundingSearchStatus.reviewing]: 'green',
  [FundingSearchStatus.approved]: 'green',
  [FundingSearchStatus.withBroker]: 'grey',
  [FundingSearchStatus.declined]: 'danger',
  [FundingSearchStatus.canceled]: 'danger',
  [FundingSearchStatus.incomplete]: 'grey',
  [FundingSearchStatus.atOffer]: 'green',
  [FundingSearchStatus.withCreditCommittee]: 'grey',
  [FundingSearchStatus.paidOut]: 'green',
  [FundingSearchStatus.awaitingDocuments]: 'warning',
  [FundingSearchStatus.capitaliseReview]: 'green',
  [FundingSearchStatus.onHold]: 'warning',
  [FundingSearchStatus.awaitingClient]: 'warning',
  [FundingSearchStatus.awaitingClientContact]: 'warning',
});
